import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - success stories banner';

export default {
  ...defineTracking({
    watchInterview: {
      category,
      action: 'click',
      label: '{name} watch interview button',
      description:
        'This event is triggered when a user clicks the Watch Interview button. ' +
        '{name} represents the name of the model the user clicked on.',
    },
  }),
};
